import React from 'react';
import { Button, LinkButton } from '../index';
import Icon from '../../Icon';
import bem from 'utils/bem';

import './index.sass';

const { el } = bem('button');

export const IconButton = ({children, name, mod, to, ...props}) => {
    const iconBtnMod = typeof(children) === 'undefined' ? 'only-icon-button' : 'icon-button';
    const btnMod = mod === undefined ?
        iconBtnMod :
        Array.isArray(mod) ?
            [...mod, iconBtnMod] :
            [mod, iconBtnMod];
    const ButtonComponent = to !== undefined ? LinkButton : Button;
    return <ButtonComponent mod={btnMod} to={to} {...props}>
        <div className={el('flex-wrap')}>
            {children}
            <Icon name={name} />
        </div>
    </ButtonComponent>
}
